<div *ngIf="chatbotUuid && contextVar">
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div [formGroup]="form" *ngIf="!loading">
    <div class="row p-0 m-0">
      <div
        [ngClass]="'col-12 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>ID</mat-label>
          <input matInput type="text" formControlName="id" class="d-block">
        </mat-form-field>
      </div>
      <div
        [ngClass]="'col-12 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>Source</mat-label>
          <input matInput type="text" formControlName="source" class="d-block">
        </mat-form-field>
      </div>
      <div
        [ngClass]="'col-12 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>Text</mat-label>
          <textarea rows="10" matInput type="text" formControlName="text" class="d-block"></textarea>
          <mat-error>Required</mat-error>
        </mat-form-field>
      </div>
    </div>
    <actions-container [ngClass]="'mx-2'">
      <button
        mat-raised-button
        color="primary"
        (click)="save()"
        [disabled]="!form.valid"
      >Save</button>
    </actions-container>
  </div>
</div>
